export default __webpack_public_path__ + "/dist/images/image00024.d9d9fb383331313e8a7db8a81848b829.jpg";